<template>
    <div>
        <div class="tw-my-3 tw-flex tw-flex-col">
            <label :for="name" class="tw-mb-3 tw-font-medium">{{ label }}</label>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-items-start">
                <input
                    :id="name"
                    :class="[
                        'tw-rounded-sm tw-p-2 tw-appearance-none',
                        (!!inputInfo ? 'md:tw-w-1/3 tw-mr-5' : 'tw-w-full'),
                        (!!additionalClasses ? additionalClasses : ''),
                        isActive ? 'tw-border-2 tw-border-black' : isHover ? 'tw-border tw-border-black' : 'tw-border tw-border-gray-300'
                    ]"
                    :style="type === 'number' ? '-moz-appearance: textfield;' : ''"
                    :name="name"
                    :placeholder="label"
                    :type="type"
                    @keydown="$emit('keydown', $event)"
                    v-model="model"
                    @focusout="isActive = false; $emit('focusout', $event)"
                    @focus="isActive = true"
                    @mouseover="isHover = true"
                    @mouseleave="isHover = false"
                    @input="$emit('change', $event)"
                />
                <span
                    class="tw-w-2/3"
                    v-if="!!inputInfo"
                >
                    {{ inputInfo }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            value: {
                required: true,
            },
            label: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: false,
                default: "text",
            },
            inputInfo: {
                type: String,
                required: false,
            },
            additionalClasses: {
                type: String,
                required: false,
            }
        },
        created() {
            this.model = this.value;
        },
        watch: {
            value() {
                this.model = Number(this.value) || this.value;
            },
            model() {
                this.$emit('input', this.model);
            },
        },
        data() {
            return {
                model: null,
                isActive: false,
                isHover: false,
            };
        }
    }
</script>

<style scoped>
    span {
        margin-left: 2px;
        margin-right: 5px;
        display: block;
    }

    label {
        display: flex;
    }
    label input {
        font-weight: 300;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Disable Safari's default active state styles */
    input:focus,
    input:active,
    input:focus-visible {
        -webkit-tap-highlight-color: transparent;
        -webkit-appearance: none;
        outline: none;
    }
</style>